import { CommonModule, DatePipe } from "@angular/common";
import { Component, computed, effect, inject, OnInit, signal } from "@angular/core";
import { TranslocoPipe } from '@jsverse/transloco';
import { SkinningService } from '@core/skin';
import { PlayerService } from "../../data-access/player.service";
import QRCode from "qrcode";

@Component({
    selector: 'player-message',
    templateUrl: "./player-message.component.html",
    styleUrls: ['./player-message.component.scss'],
    imports: [
        CommonModule,
        TranslocoPipe
    ]
})
export class PlayerMessageComponent {
    public skinning = inject(SkinningService);
    private playerService = inject(PlayerService);
    private item = this.playerService.getItem();
    private messages = signal<any[]>(null);
    public currentMessage = computed(() => {
        const position = this.playerService.getProgress()();
        return this.messages()?.find((m) => m.startAtSecond <= position && m.startAtSecond + m.duration >= position);
    });

    constructor() {
        effect(() => {
            const item = this.item();
            let counter = 0;
            this.messages.set(
                // Channel-play / VOD payloads carry no message arrays — spreading undefined throws.
                [...(item?.infoMessages ?? []), ...(item?.qrMessages ?? [])]
                    .sort((a, b) => a.startAtSecond - b.startAtSecond)
                    .map((m) => {
                        return {
                            ...m,
                            index: counter++,
                            display: true,
                            qrCodeUrl: m.url ? QRCode.toDataURL(m.url || "", { errorCorrectionLevel: 'M' }) : null
                        }
                    })
            )
        })
    }


    public close() {
        this.messages.update((messages) => messages.map((m) => m.index == this.currentMessage()?.index ? { ...m, display: false } : m))
    }
}
